// @flow
import { Companies } from './Companies';

export { Companies };
export default Companies;
